// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1186":"37c08cbd","2346":"f8835319","3382":"54c8f963"}[chunkId] + ".chunk.css";
};